import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200010Status: 'idle',
    startProcess200010Error: undefined as any,
    loadUserParamsProcess200010Status: 'idle',
    loadUserParamsProcess200010Error: undefined as any,

    process200010List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200010 = createAsyncThunk('process200010Slice/startProcess200010', async ({ process200010 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200010/`,
        prepareData(process200010),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200010Status } = getState().process200010Slice
        return startProcess200010Status !== 'pending'
    }
})

export const loadUserParamsProcess200010 = createAsyncThunk('process200010Slice/loadUserParamsProcess200010', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200010/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200010Status } = getState().process200010Slice
        return loadUserParamsProcess200010Status !== 'pending'
    }
})

const Process200010Slice = createSlice({
    name: 'process200010Slice',
    initialState,
    reducers: {
        resetstartProcess200010: (state) => {
            state.job = undefined
            state.startProcess200010Error = undefined
        },
        resetstartProcess200010Error: (state) => {
            state.startProcess200010Error = undefined
        },
        resetloadUserParamsProcess200010: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200010Error = undefined
        },
        resetloadUserParamsProcess200010Error: (state) => {
            state.loadUserParamsProcess200010Error = undefined
        },
        removeFromProcess200010ListById: (state, action) => {
            state.process200010List = state.process200010List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200010ListByIds: (state, action) => {
            state.process200010List = state.process200010List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200010List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200010Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200010List = []
            state.startProcess200010Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200010.pending, (state) => {
            state.startProcess200010Status = 'pending'
            state.startProcess200010Error = undefined
        })
        builder.addCase(startProcess200010.fulfilled, (state, action) => {
            state.startProcess200010Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200010.rejected, (state, action) => {
            state.startProcess200010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200010Error = action.error.message
            } else {
                state.startProcess200010Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200010.pending, (state) => {
            state.loadUserParamsProcess200010Status = 'pending'
            state.loadUserParamsProcess200010Error = undefined
        })
        builder.addCase(loadUserParamsProcess200010.fulfilled, (state, action) => {
            state.loadUserParamsProcess200010Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200010.rejected, (state, action) => {
            state.loadUserParamsProcess200010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200010Error = action.error.message
            } else {
                state.loadUserParamsProcess200010Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200010,
    resetstartProcess200010Error,
    resetloadUserParamsProcess200010,
    resetloadUserParamsProcess200010Error,
    removeFromProcess200010ListById,
    removeFromProcess200010ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200010Slice.actions
export default Process200010Slice.reducer
